<template>
  <div>
    <a-modal
      :visible="visible"
      width="480px"
      :footer="null"
      title=""
      :maskClosable="false"
      :closable="true"
      :keyboard="false"
      @cancel="handleCancel"
    >
      <div class="modelHeader">注销账号</div>
      <div class="send-prompt">当前账号注销后不能登录，请谨慎操作</div>
      <div class="formLogin">
        <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
          <a-form-model-item prop="phone">
            <a-input
              size="large"
              v-model="ruleForm.phoneShow"
              placeholder="请输入手机号"
              allowClear
              disabled
            />
          </a-form-model-item>
          <div class="captcha">
            <a-form-model-item prop="captcha">
              <a-input
                size="large"
                v-model="ruleForm.captcha"
                type="password"
                allowClear
                oninput="value=value.replace(/[^0-9]/g,'');if(value.length > 6)value = value.slice(0, 6)"
                placeholder="请输入验证码"
              >
                <a-button
                  slot="addonAfter"
                  class="captchaButton"
                  :disabled="captchaButtonDisabled"
                  @click="getCaptcha"
                >
                  {{ captchaBtnContent }}
                </a-button>
              </a-input>
            </a-form-model-item>
          </div>
        </a-form-model>
        <a-button class="button" :loading="btnLoading" @click="submitForm">确定注销</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { post, get } from "@/utils/http";
import { pwdPublicKeyEncode } from "@/utils/RSAUtils";
import { message, Modal } from "ant-design-vue";
import api from "@/api";
import { getLogo } from "@/utils/intConfiguration";
import { rmToken } from '@/views/login/login-handler';

export default {
  props: ["value"],
  data() {
    return {
      visible: false,
      btnLoading: false,
      ruleForm: {
        phoneShow: "",
        phone: "",
        captcha: "",
      },
      rulesPhone: [
        { required: true, message: "请输入手机号码", trigger: "blur" },
        { pattern: /^1[0-9]{10}$/, message: "手机号码格式不正确", trigger: "change" },
      ],
      rules: {
        phone: [],
      },
      rules1: {
        phone: [],
        captcha: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { pattern: /^[0-9]{6}$/, message: "验证码格式不正确", trigger: "change" },
        ],
      },
      isLogin: true, /// 用来判断校验条件
      captchaButtonDisabled: false, /// 获取验证码按钮是否禁用
      totalTime: 60, /// 倒计时
      captchaBtnContent: "获取验证码", // 按钮里显示的内容
      codeId: "", /// 验证码 id
      logoUi: getLogo(),
      errlg: null,
      errVcode: false,
      urlType: 1,
    };
  },
  watch: {
    // value: {
    //   handler() {
    //     // this.visible = this.value;
    //     if (this.visible === true) {
    //       // this.getCaptcha();
    //     }
    //   },
    // },
    // visible: {
    //   handler() {
    //     if (!this.visible) {
    //       this.ruleForm = {
    //         // pwd: "",
    //         // newPwd: "",
    //         // repeatNewPwd: "",
    //       };
    //     }
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    // this.rules.phone = this.rulesPhone;
    this.rules1.phone = this.rulesPhone;
    if (localStorage.getItem("phone")) {
      this.ruleForm.phone = localStorage.getItem("phone");
      this.ruleForm.phoneShow = this.encryptPhoneNumber(localStorage.getItem("phone"));
    }
  },
  methods: {
    // 加密手机号
    encryptPhoneNumber(phoneNumber) {
      if (!phoneNumber || phoneNumber.length < 7) {
        throw new Error("Invalid phone number");
      }
      const prefix = phoneNumber.slice(0, 3);
      const suffix = phoneNumber.slice(-4);
      const encrypted = `${prefix}****${suffix}`;
      return encrypted;
    },

    accountAdminQuery() {
      get(api.accountAdminQuery, {
        tenantId: localStorage.getItem("tenantId"),
        accountId: localStorage.getItem("accountId"),
      }).then((res) => {
        if (res && res.accountId === localStorage.getItem("accountId")) {
          this.urlType = 1;
          this.openConfirm(1);
        } else {
          this.urlType = 2;
          this.openConfirm(2);
        }
      });
    },
    openConfirm(type) {
      const self = this;
      this.$confirm({
        title: type === 1 ? "系统管理员注销账号有以下风险" : "注销账号有以下风险",
        icon: "info-circle",
        content: (h) => (
          <div>
            {type === 1 ? (
              <div>
                1. 系统管理员注销后，会同时注销本租户，租户下的员工将自动离开。
                <br />
              </div>
            ) : null}
           {type === 1 ? '2.' : '1.'}  注销后无法登录本产品应用
            <br />
            {type === 1 ? '3.' : '2.'} 注销后本产品产品内的业务数据无法找回，请按需提前备份
          </div>
        ),
        cancelText: "放弃",
        okText: "继续注销",
        onOk() {
          self.visible = true;
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
    handleCancel() {
      this.visible = false;
    },
    /// 获取验证码倒计时
    countDown() {
      this.captchaButtonDisabled = true;
      this.captchaBtnContent = `${this.totalTime}s`; // 这里解决60秒不见了的问题
      const clock = window.setInterval(() => {
        this.totalTime -= 1;
        this.captchaBtnContent = `${this.totalTime}s`;
        if (this.totalTime < 0) {
          // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.captchaBtnContent = "重新获取";
          this.totalTime = 60;
          this.captchaButtonDisabled = false;
        }
      }, 1000);
    },
    /// 获取验证码
    getCaptcha() {
      this.isLogin = false;
      setTimeout(() => {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.countDown();
            const params = {
              phone: this.ruleForm.phone,
            };
            const res = await get(api.internetSendVerifyCode, params).catch(() => {
              message.error("验证码发送失败");
              this.errlg.addErrorPhone();
            });
            this.codeId = res;
            if (res) {
              message.success("验证码已发送");
            }
          }
        });
      }, 100);
    },
    getUrl(type) {
      let url = "";
      this.urlType === 1 ? (url = api.tenantCancel) : (url = api.accountCancel);
      return url;
    },
    /// 登录操作
    submitForm() {
      this.isLogin = true;
      setTimeout(() => {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            if (this.codeId === "") {
              message.error("请先获取验证码");
              return;
            }
            if (this.ruleForm.captcha === "") {
              message.error("请输入验证码");
              return;
            }
            this.btnLoading = true;
            let params = {
              tenantId: localStorage.getItem("tenantId"),
              accountId: localStorage.getItem("accountId"),
              phone: this.ruleForm.phone,
              verifyCode: this.ruleForm.captcha,
              codeId: this.codeId,
            };
             post(this.getUrl(), params)
              .then((res) => {
                 message.success("注销成功");
                rmToken();
                setTimeout(()=>{
                  window.location.reload();
                },1500)
              })
              .catch(() => {
                // message.error('注销失败');
                // window.location.reload();
              })

              .finally(() => {
                this.btnLoading = false;
                // window.location.reload();
              });
          }
        });
      }, 100);
    },
  },
};
</script>
<style>
.ant-btn-primary {
  background-color: #3673ff;
  border-color: #3673ff;
}
.ant-btn-primary:hover,
.ant-btn-primary:focus {
  color: #fff;
  background-color: #3673ff;
  border-color: #3673ff;
}
</style>

<style lang="less" scoped>
.sys-sign-out {
  color: #fff;
  //line-height: 60px;
  border-left: 2px solid #e1e4eb;
  //margin: 0 20px 0 30px;
  cursor: pointer;
  font-size: 14px;

  //min-width: 50px;
  .user-name {
    .anticon {
      margin-left: 5px;
    }
  }
}

/deep/ .ant-modal-body {
  padding: 0 56px 56px 56px;

  .modalCloseIcon {
    color: #333;
    top: 24px;
    right: 24px;
    font-size: 22px;
    font-weight: 500;
    position: absolute;
  }

  .send-prompt {
    padding-top: 8px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
  }

  .modelHeader {
    width: 100%;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0px;
    text-align: left;
    color: #2d3968;
    padding-top: 64px;
  }

  .button {
    height: 48px;
    font-size: 16px;
    letter-spacing: 0px;
  }

  .captcha {
    display: flex;
    justify-content: space-between;

    .captchaButton {
      width: auto;
      font-size: 16px;
      font-weight: normal;
      line-height: 22px;
      color: #2255cc;
      border-color: transparent;
      padding: 0;
    }

    .captchaButton:disabled {
      font-size: 16px;
      font-weight: normal;
      line-height: 22px;
      color: #666666;
      background-color: white;
    }

    .captchaButton:hover {
      background-color: white;
      border: none;
    }

    .ant-input-group-addon {
      background: none;
      border-top: none;
      border-left: none;
      border-right: none;
      border-radius: 0;
    }
  }
}
</style>
